import { MultiVoucherFunnel } from 'app/src/features/Shopping/Direct/MultiVoucher/components/MultiVoucherFunnel'
import { shoppingApi } from 'app/src/services/welfareportal'
import { ErrorPage, PageWidget } from 'app/src/shared/components'
import { ProgressSpinner } from 'primereact/progressspinner'
import { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export function MultiVoucher(): ReactElement {
  const params = useParams()
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct.MultiVoucher' })

  const orderDetailsResponse = shoppingApi.useOrderGet({
    pathParams: { orderId: params['id']! },
  })
  return (
    <PageWidget>
      <>
        {orderDetailsResponse.isLoading || orderDetailsResponse.isFetching ? (
          <>
            <h1 className='welfareportal-titlecenter'>{t('loadingInProgressTitle')}</h1>
            <div className='mt-20 flex'>
              <div className='mx-auto'>
                <ProgressSpinner data-testid='loading-element' className='flex' />
                {t('loadingInProgressDescription') && (
                  <div className='mt-4' dangerouslySetInnerHTML={{ __html: t('loadingInProgressDescription') }} />
                )}
              </div>
            </div>
          </>
        ) : orderDetailsResponse.isError ? (
          <ErrorPage
            errorMessage={
              orderDetailsResponse.error.status == 404 ? t('voucherNotFoundMessage') : t('loadingInProgressErrorMessage')
            }
          />
        ) : (
          orderDetailsResponse.data && <MultiVoucherFunnel order={orderDetailsResponse.data} />
        )}
      </>
    </PageWidget>
  )
}
